import { useNavigate, useLocation } from "react-router";
import React, { useMemo } from 'react';
export function useURLSearchParam(){
    const search = useLocation().search;
    const searchParams = useMemo(() => new URLSearchParams(search), [search]) 
    const navigate = useNavigate();
    const onUpdate = React.useCallback((name:string, value: any) => {
        searchParams.set(name, ""+value);
        navigate({search: searchParams.toString()})        
    },[navigate, searchParams])

    return {searchParams, onUpdate};
}